import React, { useState, useCallback, useEffect, useRef } from 'react'

export function useSkipper() {
  const shouldSkipRef = useRef(true)
  const shouldSkip = shouldSkipRef.current

  const skip = useCallback(() => {
    shouldSkipRef.current = false
  }, [])

  useEffect(() => {
    shouldSkipRef.current = true
  })

  return [shouldSkip, skip]
}

export function IndeterminateCheckbox({indeterminate, className = "", ...rest}) {
  const ref = useRef(null)

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return <input type="checkbox" ref={ref} className={className + " cursor-pointer"} {...rest}/>
}

export function EditCell({ updateFunc, getValue , row: { index, original }, column: { id }, table }) {
  const ref = useRef(null)
  const initialValue = getValue()
  const [value, setValue] = useState(initialValue)
  const [updateVisible, setUpdateVisible] = useState(false)
  const onChange = e => setValue(e.target.value)
  const onFocus = e => {
    if (!e.currentTarget.contains(e.relatedTarget))
      setUpdateVisible(true)
  }
  const onBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget))
      setUpdateVisible(false)
  }
  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <div className="input-group input-group-sm" onFocus={onFocus} onBlur={onBlur}>
      <textarea
        className="form-control"
        rows={value ? value.split(/\r\n|\r|\n/).length : 1}
        resize="none"
        value={value || ""}
        onChange={onChange}
        ref={ref}
      />
      {updateVisible && <div className="input-group-append">
        <button
          type="button"
          onClick={() => {
            updateFunc(original, value)
            setUpdateVisible(false)
          }}
          className="btn btn-outline-primary"
        >
          Update
        </button>
      </div>}
    </div>
  )
}
